import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import CRUDTeacher from "../CRUD/CRUDTeacher";
import { useTranslation } from "react-i18next";

export default function NewTeacher() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader title={t("teachers.createTitle")} />
      <CardContent>
        <CRUDTeacher />
      </CardContent>
    </Card>
  );
}
